import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        padding: theme.spacing(0, 4),
        gap: theme.spacing(2),
    },
    spacer: {
        minWidth: 0,
    },
    center: {
        justifySelf: 'center',
    },
    actions: {
        minWidth: 0,
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
}));
